export const getFilteredSubcollectionObjects = (subs, facetsFromServer, objects) => {
    return subs.reduce((res, handle) => {
        const obj = objects[handle];
        if (obj !== undefined &&
            facetsFromServer[obj.facetKey]?.[obj.facetValue] !== undefined) {
            res.push(obj);
        }
        return res;
    }, []);
};
